import React from 'react';

const About = () => {
    return (
        <div className='container d-flex justify-content-center align-items-center' style={{ height: '50vh' }}>
            <div className=''>
                <h4>Name:Pranta Das.</h4>
                <p>Goal:I always cheerish the hope to become a developer.But somehow I was distracted from it .But this time I have got such a beneficial guidelilnes that now I can think that I can be a developer also.The journey has begun and I won't stop untill I see myself where I always wanted to be.Thoug there are some obstacles but no matter by the grace of almighty I will overcome all those through hard work</p>
            </div>
        </div>
    );
};

export default About;